<template>
	<!-- 导航 -->
	<div class="w-100 nbanner">
		<head-nav></head-nav>
		<div class="n_ban w-1440">
			<div class="nbanner">
				<img src="@/assets/images/nbanner.jpg" alt="" class="img_contain" />
			</div>
		</div>
	</div>
</template>

<script>
</script>

<style lang="scss">
	.nbanner {
		.nav {
			background: rgba(42, 149, 21, 0.8);

			.nav_con {
				.nav_nr {
					li {
						height: 54px !important;
						line-height: 54px !important;
						font-size: 22px !important;

						&::before {
							position: absolute;
							left: 100%;
							top: 50%;
							width: 1px;
							height: 16px;
							content: " ";
							background: #fff;
							border-radius: 0 !important;
							transform: translateY(-50%);
						}

						&:last-child {
							&::before {
								display: none;
							}
						}

						a {
							padding: 0 29px !important;

							&:hover {
								background: #0b882c !important;
								color: #fff !important;
							}
						}


					}
				}
			}
		}
	}
</style>